import React from "react"
import {
  Input,
  IconButton,
  InputRightElement,
  InputGroup,
  Box,
  useTheme,
} from "@chakra-ui/react"
import Card from "../../common/components/Card"
import { useQuery } from "@apollo/client"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/pro-light-svg-icons"
import { GetMapFeaturesFromSearchQuery } from "../graphql/map"
import NearbyFeaturesList from "./NearbyFeaturesList"
import _ from "lodash"
import useColors from "../../common/hooks/useColors"
import useDebouncedString from "../../common/hooks/useDebouncedString"

const GuidesSearch = ({
  searchStr,
  searchLabel,
  onChange,
  selectedFeature,
  onSelect,
  currentUrl,
  allowedFeatureTypes,
  hideSearchList,
  isHidingLink,
}) => {
  const { blueColor } = useColors()
  // Debounce search
  const debouncedSearchStr = useDebouncedString(searchStr, 500)
  const { data: { getMapFeaturesFromSearch = {} } = {} } = useQuery(
    GetMapFeaturesFromSearchQuery,
    {
      variables: {
        searchStr: debouncedSearchStr,
      },
      skip: !debouncedSearchStr,
    },
  )

  const flatFeatures = Object.values(
    _.omit(getMapFeaturesFromSearch, "__typename"),
  )?.flat()

  return (
    <Card
      width={["50vw", 350]}
      maxHeight={500}
      overflow="auto"
      maxWidth="100%"
      raised="true"
      borderColor={"brand.blueColor"}
      py={3}
      px={5}
      borderRadius="2rem"
      onFocus={() => {
        onChange(searchStr)
      }}
      bg="rgba(255,255,255,0.95)"
    >
      <InputGroup size="lg">
        <Input
          variant="unstyled"
          autoComplete="off"
          placeholder={
            searchLabel || "Search for Boulders, Routes, Areas or Guides..."
          }
          value={searchStr || ""}
          onChange={({ target: { value: searchStr } }) => {
            onChange(searchStr)
          }}
        />
        {searchStr ? (
          <InputRightElement mt={-2} mr={-4}>
            <IconButton
              variant="text"
              onClick={() => {
                // reset search
                onChange("")
              }}
              icon={<FontAwesomeIcon icon={faTimes} color={blueColor} />}
            />
          </InputRightElement>
        ) : null}
      </InputGroup>
      <Box>
        <NearbyFeaturesList
          features={flatFeatures}
          onSelect={onSelect}
          searchStr={searchStr}
          selectedFeature={selectedFeature}
          currentUrl={currentUrl}
          allowedFeatureTypes={allowedFeatureTypes}
          hideSearchList={hideSearchList}
          isHidingLink={isHidingLink}
        />
      </Box>
    </Card>
  )
}

export default GuidesSearch
